var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg27",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .cls-mody1 {\n        fill: #fff;\n      }\n      .cls-mody1, .cls-mody2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n      .cls-mody4 {\n        font-family: Cairo-SemiBold, Cairo;\n        font-size: 5.68px;\n        font-weight: 600;\n      }\n      .cls-mody2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MODY",
    transform: "translate(-15,-32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-mody10",
    clipPath: "url(#clippath-mody-3)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-mody2",
    d: "m 28.31,38.85 c 0,0 -0.76,0 -1.06,-0.11 -0.25,-0.1 -0.67,-0.4 -0.74,-0.4 -1.8,-0.05 -2.24,0.19 -2.92,1.01 -0.88,1.05 -3.27,3.97 -3.27,10.87 0,1.36 -0.06,2.88 0.98,3.86 0.78,0.73 4.7,1.75 7.87,1.42",
    id: "path15"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-mody5",
    clipPath: "url(#clippath-mody-4)",
    id: "g17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-mody2",
    d: "m 27.89,38.85 c 0,0 0.76,0 1.06,-0.11 0.25,-0.1 0.67,-0.4 0.74,-0.4 1.8,-0.05 2.24,0.19 2.92,1.01 0.88,1.05 3.27,3.97 3.27,10.87 0,1.36 0.06,2.88 -0.98,3.86 -0.78,0.73 -4.7,1.75 -7.87,1.42",
    id: "path16"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-mody2",
    d: "m 23.96,44.75 c 0,-2.12 1.85,-3.85 4.14,-3.85 2.29,0 4.14,1.72 4.14,3.85",
    id: "path18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-mody2",
    x1: 23.959999,
    y1: 44.75,
    x2: 32.240002,
    y2: 44.75,
    id: "line18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-mody2",
    x1: 28.1,
    y1: 40.970001,
    x2: 28.1,
    y2: 44.68,
    id: "line19"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-mody1",
    x: 18.700001,
    y: 46.939999,
    width: 18.799999,
    height: 6.5,
    rx: 0.23999999,
    ry: 0.23999999,
    id: "rect19"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-mody2",
    d: "m 27.75,36.7 c -0.22,-0.22 -0.24,-1.06 0,-1.25 0.14,-0.12 0.61,-0.14 0.72,0 0.2,0.24 0.22,1.03 0,1.25 -0.13,0.13 -0.6,0.13 -0.72,0 z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-mody4",
    transform: "translate(20.52,52.13)",
    id: "text22"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    id: "tspan20"
  }, "MO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-mody11",
    x: 8.5500002,
    y: 0,
    id: "tspan21"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-mody9",
    x: 12.04,
    y: 0,
    id: "tspan22"
  }, "Y")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMody);
export default __webpack_public_path__ + "static/media/MODY.0cc0c45984728977fbb78ce72bf5e77e.svg";
export { ForwardRef as ReactComponent };